import {
  TI_LIST, TI_LIST_SUCCESS, TI_LIST_ERROR, TI_PAGE_SET,
  TI_ADD, TI_ADD_SUCCESS, TI_ADD_ERROR,
  TI_SEARCH_CHANGE,
  TI_FILTER_TASK_STATUS_SUCCESS,
  TI_FILTER_SUPPLIERS_SUCCESS
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'idx', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  add: { loading: false, response: '' },
  search: { data: { supplier: '', task_status: '', inspection_date: '' } },
  filters: { task_status: [], suppliers: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TI_LIST: return { ...state, loading: true };
    case TI_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case TI_LIST_ERROR: return { ...state, loading: false, error: true };
    case TI_PAGE_SET: return { ...state, list: { ...state.list, page: { ...state.list.page, ...action.payload } } };
    case TI_ADD: return { ...state, add: { loading: true, response: '' } };
    case TI_ADD_SUCCESS: return { ...state, add: { loading: false, response: 'success' } };
    case TI_ADD_ERROR: return { ...state, add: { loading: false, response: 'error' } };
    case TI_SEARCH_CHANGE: return { ...state, search: { ...state.search, data: action.payload } };
    case TI_FILTER_TASK_STATUS_SUCCESS: return { ...state, filters: { ...state.filters, task_status: action.payload } };
    case TI_FILTER_SUPPLIERS_SUCCESS: return { ...state, filters: { ...state.filters, suppliers: action.payload } };
    default: return { ...state };
  }
};
